{
    "isDevelopment": true,
    "stripePublishableKey": "pk_test_51T6v4nAYxVWZxeTVMNL9b14mfORW4EJjlClOoF6NUL83LfaRMxUt9RhtJDdYqpliOCoohnocF9HwCmrNvL3sRbFU00Gp0mfTkU",
    "apiCorePath": "https://membershine-api-core-dev.azurewebsites.net/",
    "apiAuthenticationPath": "https://membershine-api-authentication-dev.azurewebsites.net/",
    "apiMessagingPath": "https://membershine-api-messaging-dev.azurewebsites.net/",
    "auth0Domain": "auth-dev.membershine.com",
    "auth0ClientId": "ZDBed9z5BBrPQ2yDCcVBna3cbXNazngY",
    "auth0Audience": "membershine-api",
    "applicationInsightsConnectionString": "InstrumentationKey=c47340cb-9f2f-4fbb-9191-af2a5167a79b;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=c0f5c4e6-1542-428a-987b-30f3326155c5",
    "maxFileSizeMb": 250,
    "memberInvitationExpirationDays": 10
}